<template>
    <div v-if="model">
        <el-form ref="form" :model="model" :rules="rules" label-width="120px" label-position="top" size="mini">
            <el-form-item label="栏目名称" prop="name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
        </el-form>
        <el-form ref="configForm" :model="model.config" :rules="configRules" label-width="120px" label-position="top"
                 size="mini">
            <el-form-item label="适用上级条件" prop="inheritPageQuery">
                <el-select v-model="model.config.inheritPageQuery">
                    <el-option :value="true" label="是"></el-option>
                    <el-option :value="false" label="否"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="图表类型" prop="chartType">
                <el-select v-model="model.config.chartType" @change="onChartTypeChange">
                    <el-option v-for="item in chartTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-form v-if="model.config.mapChartConfig" ref="mapChartConfigForm" :model="model.config.mapChartConfig" :rules="mapChartConfigRules" label-width="120px" label-position="top"
                 size="mini">
            <el-form-item label="地图位置" prop="position">
                <el-select v-model="model.config.mapChartConfig.position">
                    <el-option v-for="item in mapPositions" :key="item.value" :value="item.value" :label="item.label"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <stat-dimension-config-form ref="dimensionConfigForm" v-model="model.config.dimensionConfig"></stat-dimension-config-form>
    </div>
</template>

<script>
    import sectionService from '../../service/section'
    import StatDimensionConfigForm from './StatDimensionConfigForm'

    const chartTypes=[
        {value:'tag_cloud',label:'词云图'},
        {value:'pie',label:'饼图'},
        {value:'bar',label:'柱状图'},
        {value:'line',label:'折线图'},
        {value:'map',label:'地图'}
    ]

    const statTypes=[
        {value:'terms',label:'分类统计'},
        {value:'date',label:'时间统计'},
        {value:'custom',label:'自定义'},
    ]

    const mapPositions = [
        {value:'china',label:'中国'},
        {value:'province/beijing',label:'北京'},
        {value:'province/shanghai',label:'上海'}
    ]

    export default {
        name: "StatSectionConfigForm",
        components: {StatDimensionConfigForm},
        props: {
            id: Number
        },
        data() {
            return {
                chartTypes,
                statTypes,
                mapPositions,
                dirty: false,
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入栏目名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ]
                },
                configRules: {
                    chartType: [
                        {required: true, message: '请选择图表类型', trigger: 'blur'}
                    ],
                    inheritPageQuery: [
                        {required: true, message: '请输入是否适用上级条件', trigger: 'blur'},
                    ]
                },
                mapChartConfigRules: {
                    position: [
                        {required: true, message: '请选择地图位置', trigger: 'blur'}
                    ]
                }
            }
        },
        created(){
            this.init()
        },
        watch: {
            id() {
                this.init()
            },
            model: {
                handler(newValue, oldValue) {
                    // 只有model引用不变而内容发生变化时才将dirty设置为true
                    this.dirty = newValue === oldValue
                },
                deep: true
            }
        },
        methods: {
            async init(){
                const response = await sectionService.getSection(this.id)
                const model = response.data
                if(model.config){
                    model.config = JSON.parse(model.config)
                }else{
                    model.config = {
                        inheritPageQuery: null,
                        chartType: null,
                        dimensionConfig: null,
                        tagCloudConfig: null,
                        barChartConfig: null,
                        lineChartConfig: null,
                        mapChartConfig: null,
                        pieChartConfig: null
                    }
                }
                if (!model.config.hasOwnProperty('inheritPageQuery')) {
                    model.config.inheritPageQuery = null
                }
                this.model = model
                this.dirty = false
            },
            isDirty() {
                return this.dirty
            },
            async save(){
                const validatePromises = []
                validatePromises.push(this.$refs.form.validate())
                validatePromises.push(this.$refs.configForm.validate())
                if(this.$refs.mapChartConfigForm){
                    validatePromises.push(this.$refs.mapChartConfigForm.validate())
                }
                validatePromises.push(this.$refs.dimensionConfigForm.validate())
                await Promise.all(validatePromises)
                const data = JSON.parse(JSON.stringify(this.model))
                data.config = JSON.stringify(data.config)
                await sectionService.updateSection(data)
                this.dirty = false
            },
            onChartTypeChange(chartType){
                if(chartType==='map'){
                    this.model.config.mapChartConfig = {
                        position: null
                    }
                }else{
                    this.model.config.mapChartConfig = null
                }
            }
        }
    }
</script>

<style scoped>

</style>
